<template>
	<core-modal name="pro-feature" class="om-pro-feature" :width="888">
		<modals-header name="pro-feature" />

		<modals-content>
			<h2>{{ title }}</h2>
			<p>{{ tagline }}</p>

			<div class="omapi-get-pro__features">
				<ul class="omapi-list omapi-list__twocol">
					<li class="omapi-list__item omapi-success large">Powerful Exit Intent® Technology</li>
					<li class="omapi-list__item omapi-success large">OnSite Retargeting®</li>
					<li class="omapi-list__item omapi-success large">Campaign Scheduling</li>
					<li class="omapi-list__item omapi-success large">MonsterLinks™ (Click to Load)</li>
					<li class="omapi-list__item omapi-success large">Yes/No Forms</li>
					<li class="omapi-list__item omapi-success large">Countdown Timers</li>
					<li class="omapi-list__item omapi-success large">Spin-a-Wheel Gamified Campaigns</li>
					<li class="omapi-list__item omapi-success large">Cart & Form Abandonment</li>
				</ul>
			</div>

			<core-upgrade-button color="green" size="monster" :utm-medium="utmMedium" :features="features">
				{{ buttonText }}
			</core-upgrade-button>
			<core-upgrade-button :link-style="true" :arrow="true" :utm-medium="utmMedium" :features="features"
				>Learn more about all Pro features</core-upgrade-button
			>
		</modals-content>
	</core-modal>
</template>

<script>
export default {
	props: {
		/**
		 * The modal title.
		 *
		 * @type {string}
		 */
		title: {
			type: String,
			default: 'This feature is only available for OptinMonster Pro users.',
		},
		/**
		 * The modal tagline.
		 *
		 * @type {string}
		 */
		tagline: {
			type: String,
			default:
				'Get access to this feature, plus unlock more powerful Pro features to skyrocket your subscribers, leads and sales!',
		},
		/**
		 * The modal CTA buttonText.
		 *
		 * @type {string}
		 */
		buttonText: {
			type: String,
			default: 'Upgrade to Pro and Unlock This Feature',
		},
		/**
		 * The utm_medium query var to set on the upgrade button.
		 *
		 * @type {string}
		 */
		utmMedium: {
			type: String,
			default: 'ProFeatureUpsellModal',
		},
		/**
		 * The features to highlight in the upgrade page.
		 *
		 * @type {Array}
		 */
		features: {
			type: Array,
			default: () => [],
		},
	},
};
</script>

<style lang="scss">
@import '../../assets/scss/variables';
.om-pro-feature {
	.header {
		background-color: transparent !important;
		padding: 30px 30px 0 !important;

		.close {
			button {
				color: #b2b4b8;
			}
		}
	}

	.content {
		align-items: center;
		display: flex;
		flex-direction: column;
		padding: 0 100px 40px !important;

		h2 {
			font-weight: $font_bold;
			text-align: center;
			font-size: 24px;
			line-height: 140%;
			margin-top: 10px;
		}

		p {
			text-align: center;
			padding: 0 35px;
		}

		.omapi-list__twocol {
			justify-content: flex-end;
			.omapi-list__item {
				color: $color_black;
				margin-bottom: 16px;
				display: flex;
				align-items: center;
				flex: 0 0 45%;
			}
		}

		.omapi-button.omapi-button__monster {
			margin: 18px 0 24px;
			line-height: 100%;
		}

		.omapi-button__link {
			font-size: 14px;
			line-height: 130%;
		}
	}
}
</style>
